import Vue, { AsyncComponent } from 'vue';

interface MountElementDataset {
  mount?: string;
  vApp?: string;
}

interface MountElement extends Element {
  dataset?: MountElementDataset;
}

interface ComponentsMap {
  [name: string]: AsyncComponent;
}

/**
 * Function to mount a new Vue app to a set of nodes.
 * Allows to pass data-* attributes as props to the components.
 *
 * @param componentsMap ComponentsMap
 */
function mountComponentsMap(componentsMap: ComponentsMap) {
  document.querySelectorAll('[data-mount]').forEach((element: MountElement) => {
    const dataSelector = element.dataset?.mount;

    if (undefined === dataSelector) {
      throw new Error(`Empty mount data attribute found.`);
    }

    const instance = componentsMap[dataSelector];

    if (undefined === instance) {
      throw new Error(`Cannot find instance for ${dataSelector}`);
    }

    const props = Object.assign({}, element.dataset);
    delete props.mount;
    delete props.vApp;

    const app = new Vue({
      render: (h) => h(instance, { props })
    });

    app.$mount(element);
  });
}

/**
 * Function to mount the configurator once.
 *
 * @param configurator AsyncComponent
 */
export function mountConfiguratorOnce(configurator: AsyncComponent) {
  if ((window as any).__configuratorMounted) {
    return;
  }

  (window as any).__configuratorMounted = true;

  const map = {
    configurator
  };

  mountComponentsMap(map);
}
